import React, { useMemo } from 'react';
// @ts-ignore
import styles from './RequirementsListItemStatusBadge.module.scss';
import Tooltip from '../../../Components/Popup/Tooltip';
import { RequirementsListItemStatus } from '../Enums/RequirementsListItemStatus.enum';
import useTranslation from '../../../Hooks/useTranslation';

interface Props {
	status: RequirementsListItemStatus;
}

const RequirementsListItemStatusBadge: React.FC<Props> = ({ status }) => {
	const { t } = useTranslation();

	const data: Record<
		RequirementsListItemStatus,
		{ icon: string; title: string }
	> = {
		[RequirementsListItemStatus.NOT_UPLOADED]: {
			icon: '/dist/requirements/circle-xmark-solid.svg',
			title: t('component.requirementsListItemStatusBadge.notUploaded') ?? '',
		},
		[RequirementsListItemStatus.WAITING_FOR_APPROVE]: {
			icon: '/dist/requirements/circle-check-solid-gray.svg',
			title:
				t('component.requirementsListItemStatusBadge.waitingForApprove') ?? '',
		},
		[RequirementsListItemStatus.APPROVED]: {
			icon: '/dist/requirements/circle-check-solid.svg',
			title: t('component.requirementsListItemStatusBadge.approved') ?? '',
		},
	};

	return (
		<div className={styles.item}>
			<Tooltip
				position='bottom left'
				trigger={
					<img
						className={styles.icon}
						src={data[status].icon}
						alt={data[status].title}
					/>
				}>
				{data[status].title}
			</Tooltip>
		</div>
	);
};

export default RequirementsListItemStatusBadge;
